import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { UiFormModule } from '../../../shared/ui/ui-form.module';
import { CreditAttachmentDialogComponent } from './components/credit-attachment-dialog/credit-attachment-dialog.component';
import { CreditConstitutionDialogComponent } from './components/credit-constitution-dialog/credit-constitution-dialog.component';
import { CreditFormDialogComponent } from './components/credit-form-dialog/credit-form-dialog.component';
import { CreditDetailPanelComponent } from './components/credit-detail-panel/credit-detail-panel.component';
import { CreditInstallmentsDialogComponent } from './components/credit-installments-dialog/credit-installments-dialog.component';
import { CreditShortTermDebtDialogComponent } from './components/credit-short-term-debt-dialog/credit-short-term-debt-dialog.component';

@NgModule({
  declarations: [
    CreditAttachmentDialogComponent,
    CreditConstitutionDialogComponent,
    CreditDetailPanelComponent,
    CreditFormDialogComponent,
    CreditInstallmentsDialogComponent,
    CreditShortTermDebtDialogComponent,
  ],
  exports: [
    CreditAttachmentDialogComponent,
    CreditConstitutionDialogComponent,
    CreditDetailPanelComponent,
    CreditFormDialogComponent,
    CreditInstallmentsDialogComponent,
    CreditShortTermDebtDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiFormModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class CreditSharedModule { }
